/**
 * @file   src\components\Onboarding\UserRegister\CheckAgentModal.js
 * @brief  This file is responsible for agent onboarding success modal
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import RadioButtonGroup from "../../Common/RadioButtonGroup";
import { USER_TYPE_AGENT, USER_TYPE_MEMBER } from "../../../constants/common";

const CheckAgentModal = (props) => {
  const {
    show,
    handleUserTypeContinueClick,
    handleUserTypeSelection,
    isDisabled,
    selectedType,
    onCancel,
  } = props;
  const itemArray = [
    { text: "Yes", id: USER_TYPE_AGENT },
    { text: "No", id: USER_TYPE_MEMBER },
  ];
  return (
    <Modal
      show={show}
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className="modal-custom-width"
      onHide={onCancel}
    >
      <Modal.Body className="pb-32 pt-32">
        {onCancel && (
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onCancel}
          ></button>
        )}
        <h3 className="text-start">Let’s create your profile!</h3>
        <p className="mb-30 ln-24 f-size-16 para-color-first">
          We're here to help you meet you and your real estate goals. Let's get
          started by setting up your profile.{" "}
        </p>

        <p className="f-size-16 f-medium mb-3 para-color-second">
          Are you a licensed real estate agent or property manager?{" "}
        </p>

        <div className="wantad-timing-wrap">
          <RadioButtonGroup
            list={itemArray}
            onChange={(e) => handleUserTypeSelection(e)}
            selectedValue={selectedType}
          />
        </div>

        <Button
          disabled={isDisabled}
          variant="primary"
          className={isDisabled ? "btn w-100 mb-2 disabled" : "btn w-100 mb-2"}
          onClick={() => handleUserTypeContinueClick()}
        >
          Continue
        </Button>

        {onCancel && (
          <Button
            variant="link"
            className="btn w-100 onboarding-skip-link"
            onClick={onCancel}
          >
            I'll do this later
          </Button>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CheckAgentModal;